import React, { useEffect, useState } from 'react';
import AssetHomeCollection from '../common/AssetHomeCollection';

export function CollectionsHome(props) {
    return (
        <div className={'assethome collections'}>
            <div className={'desc'}>
                <h1>All Collections</h1>
            </div>
            <div className={'c-asset-collection'}>
                <AssetHomeCollection asset_type={'collections'} />
            </div>
        </div>
    );
}

export default CollectionsHome;
